/**
 * Phase 23 (Plan 23-02) — API client for the bundled dashboard summary endpoint.
 *
 * Mirrors `services/notifications.ts:34-50` axios + `toApiError` pattern.
 */

import { api } from '@/lib/api/axios';
import { toApiError } from '@/lib/api/error';
import { THROUGHPUT_DAYS_DEFAULT } from '@/lib/storage/throughput-window';
import type { DashboardSummary } from '@/types/dashboard';

/**
 * `GET /api/dashboard/summary` — bundled multi-widget dashboard payload.
 * Issue #6: `throughputDays` selects the logsheet-throughput window
 * (default 14; the server silently clamps to [7, 90]).
 */
export async function getDashboardSummaryRequest(
  throughputDays: number = THROUGHPUT_DAYS_DEFAULT,
): Promise<DashboardSummary> {
  try {
    const { data } = await api.get<DashboardSummary>('/api/dashboard/summary', {
      params: { throughputDays },
    });
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}
